module.exports = __webpack_public_path__ + "img/temp_instagram2.b7ecbb8c.jpg";